<template>
  <!--基本信息-->
	<div id="my_basic_information" class="my_basic_information_top">
    <!--<van-col span="22" offset="1">
      &lt;!&ndash; 更换头像 &ndash;&gt;
      <van-col span="24" @click="img_upload('avatar')">
        <van-col span="24" class="my_information_avatar2">
          <van-image round width="4em" height="4em" :src="user.avatar" fit="cover" v-if="user.avatar"/>
          <img src="../assets/img/avatar.png" class="avatar2" v-else>
        </van-col>
      </van-col>
      &lt;!&ndash;<van-col span="24" class="avatar2-text avatar_title" >{{ $t('column.change_avatar')}}</van-col>&ndash;&gt;
    </van-col>-->
    <van-col span="22" offset="1">
      <!--头像-->
      <van-col span="24" class="my_information_type" @click="img_upload('avatar')">
        <van-cell-group>
          <van-field  v-model="user.avatar" :label="$t('user.Avatar')" is-link>
            <template #input>
              <van-col span="24" class="my_add_avatar">
                <van-image round width="4em" height="4em"  :src="user.avatar" fit="cover" v-if="user.avatar" />
                <img src="../assets/img/avatar.png" class="avatar2" v-else>
              </van-col>
            </template>
          </van-field>
        </van-cell-group>
      </van-col>
      <!-- 昵称 -->
      <van-col span="24" class="my_information_type">
        <van-cell-group>
          <van-field v-model="user.user_nickname" label-width="120px" :label="$t('user.Nickname')" is-link/>
        </van-cell-group>
      </van-col>
      <!-- 年龄 -->
      <van-col span="24" class="my_information_type">
        <van-cell :title="$t('user.ages')" @click="showage = true" :value="user.age" is-link/>
        <van-action-sheet v-model="showage">
          <van-picker
            :default-index="2"
            :title="$t('user.ages')"
            show-toolbar
            :columns = 'options_age'
            @confirm = 'onConfirmAge'
            @cancel = 'onChangeAges'
            :confirm-button-text="$t('btn.submit')"
            :cancel-button-text="$t('btn.cancel')"
          />
        </van-action-sheet>
      </van-col>
      <!-- 城市 -->
      <van-col span="24" class="my_information_type">
        <van-cell  :title="$t('user.city')" @click="showcity = true" :value="user | getcity" is-link/>
        <van-action-sheet v-model="showcity">
          <van-picker
            :title="$t('user.city')"
            show-toolbar
            :columns="options7"
            @confirm="onConfirmcity"
            @cancel="onChangecitys"
            :confirm-button-text="$t('btn.submit')"
            :cancel-button-text="$t('btn.cancel')"
          />
        </van-action-sheet>
      </van-col>
      <!-- 身高 -->
      <!--    <van-col span="24" class="my_information_type">
        <van-cell :title="$t('user.height')" @click="showheight = true" :value="user.height" is-link/>
        <van-action-sheet v-model="showheight">
          <van-picker
            :title="$t('user.height')"
            show-toolbar
            :columns="options_height"
            @confirm="onConfirmheight"
            @cancel="onChangeheights"
            :confirm-button-text="$t('btn.submit')"
            :cancel-button-text="$t('btn.cancel')"
          />
        </van-action-sheet>
      </van-col>-->
      <!-- 职业 -->
      <!--   <van-col span="24" class="my_information_type">
        <van-cell :title="$t('user.occupation')" @click="showprofessional = true" :value="user.professional" is-link/>
        <van-action-sheet v-model="showprofessional">
          <van-picker
            :title="$t('user.occupation')"
            show-toolbar
            :columns="options6"
            @confirm="onConfirmprofessional"
            @cancel="onChangeprofessionals"
            :confirm-button-text="$t('btn.submit')"
            :cancel-button-text="$t('btn.cancel')"
          />
        </van-action-sheet>
      </van-col>-->
    </van-col>
    <van-col span="24" class="basic_information_bg"></van-col>
    <!-- 交友心声-->
    <van-col span="24" class="my_information_title_bg">
      <van-col span="22" offset="1" class="my_information_title">{{ $t('column.voice_making_friends')}}</van-col>
    </van-col>
    <van-col span="22" offset="1" class="my_information_textarea">
      <van-field
        v-model="user.signature"
        rows="5"
        type="textarea"
        maxlength="500"
        :placeholder="$t('placeholder.voice_making_friends')"
        show-word-limit
      />
    </van-col>
    <van-col span="24" class="basic_information_bg"></van-col>
    <!-- Collapse 折叠面板 -->
   <!-- <van-col span="22" offset="1" class="my_information_type">
      <van-collapse v-model="activeNames">
        <van-collapse-item :title="$t('column.more_information')" name="1" class="Collapse_title">
          <van-col span="24">

            &lt;!&ndash; 学历 &ndash;&gt;
            <van-col span="24" class="my_information_type">
              <van-cell :title="$t('user.education')" @click="showdiploma = true" :value="user.diploma" is-link/>
              <van-action-sheet v-model="showdiploma" :actions="options1" @select="ondiploma" :cancel-text="$t('btn.cancel')" close-on-click-action/>
            </van-col>
            &lt;!&ndash; 月收入 &ndash;&gt;
            <van-col span="24" class="my_information_type">
              <van-cell :title="$t('user.monthly_income')" @click="showincome = true" :value="user.monthly_income" is-link/>
              <van-action-sheet v-model="showincome" :actions="income_array" @select="onincome" :cancel-text="$t('btn.cancel')" close-on-click-action/>
            </van-col>
            &lt;!&ndash; 婚姻状况 &ndash;&gt;
            <van-col span="24" class="my_information_type">
              <van-cell :title="$t('user.marital_status')" @click="showmarriage = true" :value="user.marriage" is-link/>
              <van-action-sheet v-model="showmarriage" :actions="options2" @select="onmarriage" :cancel-text="$t('btn.cancel')" close-on-click-action/>
            </van-col>
            &lt;!&ndash; 体型 &ndash;&gt;
            <van-col span="24" class="my_information_type">
              <van-cell :title="$t('user.shape')" @click="showshape = true" :value="user.shape" is-link/>
              <van-action-sheet v-model="showshape" :actions="options_shape" @select="onshape" :cancel-text="$t('btn.cancel')" close-on-click-action/>
            </van-col>
            &lt;!&ndash; 有无子女 &ndash;&gt;
         &lt;!&ndash;   <van-col span="24" class="my_information_type">
              <van-cell :title="$t('user.children')" @click="showchildren = true" :value="user.children" is-link/>
              <van-action-sheet v-model="showchildren" :actions="options_children" @select="onchildren" :cancel-text="$t('btn.cancel')" close-on-click-action/>
            </van-col>&ndash;&gt;
            &lt;!&ndash; 血型 &ndash;&gt;
            <van-col span="24" class="my_information_type">
              <van-cell :title="$t('user.blood_type')" @click="showblood = true" :value="user.blood_type" is-link/>
              <van-action-sheet v-model="showblood" :actions="blood_type" @select="onblood" :cancel-text="$t('btn.cancel')" close-on-click-action/>
            </van-col>
            &lt;!&ndash; 出生地 &ndash;&gt;
            <van-col span="24" class="my_information_type">
              <van-cell  :title="$t('user.birthplace')" @click="showcity = true" :value="user.birthplace" is-link/>
              <van-action-sheet v-model="showcity">
                <van-picker
                  :title="$t('user.birthplace')"
                  show-toolbar
                  :columns="options7"
                  @confirm="onConfirmbirthplace"
                  @cancel="onChangebirthplace"
                  :confirm-button-text="$t('btn.submit')"
                  :cancel-button-text="$t('btn.cancel')"
                />
              </van-action-sheet>
            </van-col>
            &lt;!&ndash; 吸烟情况 &ndash;&gt;
            <van-col span="24" class="my_information_type">
              <van-cell :title="$t('user.Smoking')" @click="showSmoking = true" :value="user.Smoking" is-link/>
              <van-action-sheet v-model="showSmoking" :actions="Smoking" @select="onSmoking" :cancel-text="$t('btn.cancel')" close-on-click-action/>
            </van-col>
            &lt;!&ndash; 饮酒情况 &ndash;&gt;
            <van-col span="24" class="my_information_type">
              <van-cell :title="$t('user.drinking_situation')" @click="showdrinking = true" :value="user.drinking_situation" is-link/>
              <van-action-sheet v-model="showdrinking" :actions="drinking_situation" @select="ondrinking" :cancel-text="$t('btn.cancel')" close-on-click-action/>
            </van-col>
            &lt;!&ndash; 兄弟姐妹 &ndash;&gt;
            <van-col span="24" class="my_information_type">
              <van-cell :title="$t('user.brothers_sisters')" @click="showbrothers = true" :value="user.brothers_sisters" is-link/>
              <van-action-sheet v-model="showbrothers" :actions="brothers_sisters" @select="onbrothers" :cancel-text="$t('btn.cancel')" close-on-click-action/>
            </van-col>
            &lt;!&ndash; 国籍&ndash;&gt;
            <van-col span="24" class="my_information_type">
              <van-cell :title="$t('user.nationality')" @click="shownationality = true" :value="user.nationality" is-link/>
              <van-action-sheet v-model="shownationality">
                <van-picker
                  :title="$t('user.nationality')"
                  show-toolbar
                  :columns = 'nationality'
                  @confirm = 'onConfirmshownationality'
                  @cancel = 'onChangeshownationalitys'
                  :confirm-button-text="$t('btn.submit')"
                  :cancel-button-text="$t('btn.cancel')"
                />
              </van-action-sheet>
            </van-col>
            &lt;!&ndash; 语言  -&#45;&#45;  性格  &ndash;&gt;
            <van-col span="24" class="my_information_type">
              <van-collapse v-model="showlanguage" accordion>
                &lt;!&ndash; 语言 &ndash;&gt;
                <van-collapse-item :title="$t('user.language')" name="1" class="language_type">
                  <van-tag v-for="(l,i) in language" :key="l.id"  :class="l.status == 1 ? 'language_type_checked' : 'language_type_center'" @click="language_btn(i)">{{ l.title }}</van-tag>
                </van-collapse-item>
                &lt;!&ndash; 性格 &ndash;&gt;
                <van-collapse-item :title="$t('user.character')" name="2" class="language_type">
                  <van-tag v-for="(l,i) in character" :key="l.id" :class="l.status == 1 ? 'language_type_checked' : 'language_type_center'" @click="character_btn(i)">{{ l.title }}</van-tag>
                </van-collapse-item>
              </van-collapse>
            </van-col>
            &lt;!&ndash; 毕业院校 &ndash;&gt;
            <van-col span="24" class="my_information_type more_information_color">
              <van-cell-group>
                <van-field v-model="user.school" :label="$t('user.school')" right-icon="arrow"/>
              </van-cell-group>
            </van-col>
            &lt;!&ndash; 对结婚的要求 &ndash;&gt;
           &lt;!&ndash; <van-col span="24" class="my_information_type">
              <van-cell :title="$t('user.requirements_marriage')" @click="showrequirements = true" :value="user.requirements_marriage" is-link/>
              <van-action-sheet v-model="showrequirements" :actions="requirements_marriage" @select="onrequirements" :cancel-text="$t('btn.cancel')" close-on-click-action/>
            </van-col>&ndash;&gt;
            &lt;!&ndash; 要不要小孩 &ndash;&gt;
        &lt;!&ndash;    <van-col span="24" class="my_information_type">
              <van-cell :title="$t('user.want_children')" @click="showWantchildren = true" :value="user.want_children" is-link/>
              <van-action-sheet v-model="showWantchildren" :actions="want_children" @select="WantChildren" :cancel-text="$t('btn.cancel')" close-on-click-action/>
            </van-col>&ndash;&gt;
            &lt;!&ndash;  交友状态  &ndash;&gt;
        &lt;!&ndash;    <van-col span="24" class="my_information_type">
              <van-cell :title="$t('user.friendship_status')" @click="showfriendship = true" :value="user.friendship_status" is-link/>
              <van-action-sheet v-model="showfriendship" :actions="friendship_status" @select="onfriendship" :cancel-text="$t('btn.cancel')" close-on-click-action/>
            </van-col>&ndash;&gt;
            &lt;!&ndash; 约会费用 &ndash;&gt;
          &lt;!&ndash;  <van-col span="24" class="my_information_type">
              <van-cell :title="$t('user.appointment_fee')" @click="showappointment = true" :value="user.appointment_fee" is-link/>
              <van-action-sheet v-model="showappointment" :actions="appointment_fee" @select="onappointment" :cancel-text="$t('btn.cancel')" close-on-click-action/>
            </van-col>&ndash;&gt;
            &lt;!&ndash; 居住情况 &ndash;&gt;
            <van-col span="24" class="my_information_type">
              <van-cell :title="$t('user.living_conditions')" @click="showliving = true" :value="user.living_conditions" is-link/>
              <van-action-sheet v-model="showliving" :actions="living_conditions" @select="onliving" :cancel-text="$t('btn.cancel')" close-on-click-action/>
            </van-col>
            &lt;!&ndash; 休息日 &ndash;&gt;
            <van-col span="24" class="my_information_type">
              <van-cell :title="$t('user.rest_day')" @click="showday = true" :value="user.rest_day" is-link/>
              <van-action-sheet v-model="showday" :actions="rest_day" @select="onrestday" :cancel-text="$t('btn.cancel')" close-on-click-action/>
            </van-col>
            &lt;!&ndash; 社交性 &ndash;&gt;
            <van-col span="24" class="my_information_type">
              <van-cell :title="$t('user.sociality')" @click="showsociality = true" :value="user.sociality" is-link/>
              <van-action-sheet v-model="showsociality" :actions="sociality" @select="onsociality" :cancel-text="$t('btn.cancel')" close-on-click-action/>
            </van-col>
            &lt;!&ndash; 兴趣爱好 &ndash;&gt;
            <van-col span="24" class="my_information_type more_information_color">
              <van-cell-group>
                <van-field v-model="user.hobby" :label="$t('user.hobby')" right-icon="arrow"/>
              </van-cell-group>
            </van-col>
          </van-col>
        </van-collapse-item>
      </van-collapse>
    </van-col>-->
    <van-overlay :show="is_loading" style="background-color: rgba(0,0,0,0.5);">
      <van-loading type="spinner" color="#ffffff" style="margin-top:50vh"/>
    </van-overlay>

    <!-- 保存 -->
    <!--<van-col span="18" offset="3" @click="submits">
      <van-button type="primary" size="large" class="my_information_btn" safe-area-inset-bottom>{{ $t('btn.preservation')}}</van-button>
    </van-col>-->
    <van-col span="24"  @click="submits">
      <van-button class="my_add_info_button" type="primary" round block native-type="submit">{{ $t('btn.preservation') }}</van-button>
      </van-col>

  </div>
</template>
<!--<script src="path/to/vconsole.min.js"></script>-->
<script>
  import '@/assets/css/style.css'
  import { judgeIosAndroid } from '@/assets/js/models.js'
	import axios from 'axios'
  import { Toast, Uploader, Collapse, CollapseItem, Overlay, Loading } from 'vant'
//  import VConsole from 'vconsole/dist/vconsole.min.js' //import vconsole
 // let vConsole = new VConsole();
	export default {
    filters: {
      getcity (u) {
        return u.province +' '+ u.city
      }
    },
		data() {
			return {
        is_loading: false,
        activeNames: [],
        showprofessional: false,
        showmarriage: false,
        showincome: false,
        showdiploma: false,
        showheight: false,
        showcity: false,
        showage: false,
        showshape: false,
        showchildren: false,
        showWantchildren: false,
        options1: [],
        options2: [],
        showblood: false,
        showSmoking: false,
        showdrinking: false,
        showbrothers: false,
        shownationality: false,
        showrequirements: false,
        showfriendship: false,
        showappointment: false,
        showcharacter: false,
        showliving: false,
        showday: false,
        showsociality: false,
				user: {
					"user_nickname":"",  // 用户昵称
			        "avatar":"",       // 用户头像
			        "height":'',       // 身高
			        "age":'',          // 年龄
			        "diploma":"",      // 学历
			        "marriage":"",      // 婚姻状况
			        "monthly_income":"", // 月收入
			        "professional":"",  // 职业
			        "signature":"",   // 交友心声
			        "province" :'',   // 省
			        "city" :'',        // 市
              "children":'',  // 有无子女
              "shape" : '', // 体型
              "blood_type":"",  // 血型
              "birthplace":"",       // 出生地
              "Smoking":'',       // 吸烟情况
              "drinking_situation":'',          // 饮酒情况
              "brothers_sisters":"",      // 兄弟姐妹
              "nationality":"",      // 国籍
              "language":"",     // 语言 多个用逗号隔开
              "school":"",      // 毕业院校
              "requirements_marriage":"",   // 对结婚要求
              "want_children" :'',   // 要不要小孩
              "friendship_status" :'',        // 交友状态
              "appointment_fee":'',  // 约会费用
              "character" : '', // 性格，多个用逗号隔开
              "living_conditions" : '', // 居住情况
              "rest_day" : '', // 休息日
              "sociality" : '', // 社交性
              "hobby" : '', // 兴趣爱好
				},
        options_age:[],
        options_height:[],
				income_array: [],
        options_children: [],
        options_shape: [],
				options6: [],
				options7: [],             // {value: 'zhinan',label: '指南', children: [{value: 'shejiyuanze',label: '设计原则'}]},
        blood_type:[],
        showlanguage: '',
        birthplace:[],
        Smoking: [],
        drinking_situation: [],
        brothers_sisters: [],
        nationality: [],
        language: [],             // {value: 'zhinan',label: '指南', children: [{value: 'shejiyuanze',label: '设计原则'}]},
        requirements_marriage: [],
        want_children: [],
        friendship_status: [],
        appointment_fee: [],
        living_conditions: [],
        rest_day: [],
        sociality: [],
        character:[],
			};
		},
		created: function() {
			this.professional_income()
      this.region_list()
			document.title = this.$t('title.personal_data')
		},
		 components: {
	      [Uploader.name]: Uploader,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Overlay.name]: Overlay,
        [Loading.name]: Loading
	  },
    mounted() {
      // 将要给原生调用的方法挂载到 window 上面
      window.getValueFromApp = this.getValueFromApp
    },
		methods: {
      img_upload (name) {
        // 上传头像
        this.mobile_intercept(name)
      },
      mobile_intercept(name) {
        //  拦截
        const isIos = judgeIosAndroid();
      //  this.is_loading = true
        if (isIos == true) {
          // ios传值方法postMessage（val）传值方式
          window.webkit.messageHandlers.upload_avatar.postMessage(name)
        } else {
          // ios传值方法goSubmitted（val）传值方式
          window.AndroidJs.upload_avatar(name)
        }
      },
      getValueFromApp(name,url) {
        // 上传回调
        // 下载完成回调(ios和android调用接口)
        if (name === 'avatar') {
          this.user.avatar = url
        }
      //  this.is_loading = false
      },
      onConfirmAge (val) {
        // 年龄确认
        this.user.age = val
        this.showage = false
      },
      onChangeAges () {
        this.showage = false
      },
      onConfirmcity (val) {
        // 地址确认
        this.user.province = val[0]
        this.user.city = val[1]
        this.showcity = false
      },
      onChangecitys () {
        this.showcity = false
      },
      onConfirmheight (val) {
        // 身高确认
        this.user.height = val
        this.showheight = false
      },
      onChangeheights () {
        this.showheight = false
      },
      ondiploma (item) {
        // 学历
        this.user.diploma = item.name
        this.showdiploma = false
      },
      onincome (item) {
        // 月收入
        this.user.monthly_income = item.name
        this.showincome = false
      },
      onshape (item) {
        // 体型
        this.user.shape = item.name
        this.showshape = false
      },
      onmarriage (item) {
        // 婚姻状况
        this.user.marriage = item.name
        this.showmarriage = false
      },
      onchildren (item) {
        // 有无子女
        console.log(item)
        this.user.children = item.name
        this.showchildren = false
      },
      onConfirmprofessional (val) {
        // 职业确认
        this.user.professional = val[1]
        this.showprofessional = false
      },
      onChangeprofessionals () {
        this.showprofessional = false
      },
      // 血型
      onblood (item) {
        this.user.blood_type = item.name
        this.showblood = false
      },
      // 地址确认
      onConfirmbirthplace (val) {
        this.user.birthplace = val[0] + val[1]
        this.showcity = false
      },
      onChangebirthplace () {
        this.showcity = false
      },
      // 吸烟情况
      onSmoking (item) {
        this.user.Smoking = item.name
        this.showSmoking = false
      },
      //饮酒情况
      ondrinking (item){
        this.user.drinking_situation = item.name
        this.showdrinking = false
      },
      // 兄弟姐妹
      onbrothers (item) {
        this.user.brothers_sisters = item.name
        this.showbrothers = false
      },
      // 国籍确认
      onConfirmshownationality (val) {
        this.user.nationality = val
        this.shownationality = false
      },
      onChangeshownationalitys () {
        this.shownationality = false
      },
      // 对结婚的要求
      onrequirements(item){
        this.user.requirements_marriage = item.name
        this.showrequirements = false
      },
      // 要不要小孩
      WantChildren(item) {
        this.user.want_children = item.name
        this.showWantchildren = false
      },
      //交友状态
      onfriendship(item) {
        this.user.friendship_status = item.name
        this.showfriendship = false
      },
      // 约会费用
      onappointment(item) {
        this.user.appointment_fee = item.name
        this.showappointment = false
      },
      // 居住情况
      onliving(item) {
        this.user.living_conditions = item.name
        this.showliving = false
      },
      // 休息日
      onrestday(item) {
        this.user.rest_day = item.name
        this.showday = false
      },
      // 社交性
      onsociality(item) {
        this.user.sociality = item.name
        this.showsociality = false
      },
      // 语言
      language_btn(i) {
        this.language[i].status = this.language[i].status == 1 ? 0 : 1
        console.log(this.language)
      },
      // 性格
      character_btn(i) {
        this.character[i].status = this.character[i].status == 1 ? 0 : 1
        console.log(this.character)
      },
			convert: function() {
				let i;
        this.options_age = []

        this.options_age.push(this.$t('user.AgedeFault'))
				for(i = 18; i <=70; i++) {
					this.options_age.push(i)
				}
				this.options_height = []
				for(i = 133; i <=199; i++) {
					this.options_height.push(i)
				}
				const uid = this.$route.query.uid
				const token = this.$route.query.token
				axios.get(this.baseUrlApi + "mapi/public/index.php/api/user_api/vue_get_user_information", {
					params: {
						uid: uid,
						token: token
					}
				}).then(res => {
					if(res.data.code == 1){
            this.user = res.data.data;

            for(let i=0;i < this.language.length; i++ ){
              const tag= this.language[i].title
              if (this.user.language && this.user.language.indexOf(tag) != -1) {
                this.language[i].status = 1
              }else{
                this.language[i].status = 0
              }
            }
            // character 性格
            for(let i=0;i < this.character.length; i++ ){
              const character_tag= this.character[i].title
              if (this.user.character && this.user.character.indexOf(character_tag) != -1) {
                this.character[i].status = 1
              }else{
                this.character[i].status = 0
              }
            }
            this.user.age = this.user.age === 0 ? this.$t('user.AgedeFault') : this.user.age
						/*this.user.user_nickname = res.data.data.user_nickname;
						this.user.avatar = res.data.data.avatar;
						this.user.height = res.data.data.height ? res.data.data.height :'';
						this.user.age = res.data.data.age ? res.data.data.age : '';
						this.user.diploma = res.data.data.diploma;
						this.user.marriage = res.data.data.marriage;
						this.user.monthly_income = res.data.data.monthly_income;
						this.user.professional = res.data.data.professional;
						this.user.signature = res.data.data.signature;
						this.user.city = res.data.data.city;
						this.user.province = res.data.data.province;
            this.user.shape = res.data.data.shape;
            this.user.children = res.data.data.children;*/
					}
				})
			},
      // 城市
      region_list() {
        this.options7 = []
        //    const appData = require('../../city.json') // 加载本地数据文件
        const uid = this.$route.query.uid;
        const token = this.$route.query.token;
        axios.get(this.baseUrlApi + "mapi/public/index.php/api/user_api/get_region_list", { params: { uid: uid,token: token}}).then(res => {
          console.log(res.data.data)
          let appData = res.data.data
          for(let i= 0;i< appData.length; i++){
            const professional_list = appData[i].cities
            const  children =[]
            for(let s=0; s < professional_list.length; s++){
              children[s] ={ text: professional_list[s]['areaName'],label: professional_list[s]['areaName']}
            }
            this.options7.push({'text': appData[i]['areaName'],'label': appData[i]['areaName'],'children': children})
          }
          console.log(this.options7)
        })
      },
			professional_income() {
				const uid = this.$route.query.uid;
				const token = this.$route.query.token;
				axios.get(this.baseUrlApi + "mapi/public/index.php/api/user_api/professional_income", {
					params: {
						uid: uid,
						token: token
					}
				}).then(res => {
				  console.log(res)
          // 收入
/*					this.income_array = []
					const incomearr= res.data.data.income
					for(let i= 0;i< incomearr.length; i++){
            const income = {'name': incomearr[i]['name'] }
            this.income_array.push(income)
					}*/
					// 婚姻
/*          this.options2 = []
          const marriage= res.data.data.marriage
          for(let i= 0;i< marriage.length; i++){
            const marriage_name = {'name': marriage[i]['name'] }
            this.options2.push(marriage_name)
          }*/
          // 学历
  /*        this.options1 = []
          const education= res.data.data.education
          for(let i= 0;i< education.length; i++){
            const education_name = {'name': education[i]['name'] }
            this.options1.push(education_name)
          }*/
          // 职业
/*					const professional =res.data.data.professional
					this.options6 =[]
					if(professional){
						for(let i= 0;i< professional.length; i++){
							const professional_list = professional[i].professional_list
					    const  children =[]
							for(let s=0; s < professional_list.length; s++){
								children[s] ={ text: professional_list[s]['name'],label: professional_list[s]['name']}
							}
							this.options6.push({'text': professional[i]['name'],'label': professional[i]['name'],'children': children})
						}
					}*/
          // 体型
/*          this.options_shape = []
          const shape= res.data.data.shape
          for(let i= 0;i< shape.length; i++){
            const shape_name = {'name': shape[i]['title'] }
            this.options_shape.push(shape_name)
          }*/
          // 有无子女
         /* this.options_children = []
          const children= res.data.data.children
          for(let i= 0;i< children.length; i++){
            const children_name = {'name': children[i]['title'] }
            this.options_children.push(children_name)
          }*/
      //    this.more_information()
          this.convert()
				})
			},
      // 获取更多选项
      more_information() {
        const uid = this.$route.query.uid;
        const token = this.$route.query.token;
        axios.get(this.baseUrlApi + "mapi/public/index.php/api/user_api/get_more_information_val", {
          params: {
            uid: uid,
            token: token
          }
        }).then(res => {
          console.log(res)
          // 血型
          this.blood_type = []
          const blood_type = res.data.data.blood_type
          for(let i= 0;i< blood_type.length; i++){
            const blood_mame = {'name': blood_type[i]['title'] }
            this.blood_type.push(blood_mame)
          }
          // 吸烟情况
          this.Smoking = []
          const Smoking= res.data.data.Smoking
          for(let i= 0;i< Smoking.length; i++){
            const Smoking_name = {'name': Smoking[i]['title'] }
            this.Smoking.push(Smoking_name)
          }
          // 饮酒情况
          this.drinking_situation = []
          const drinking_situation= res.data.data.drinking_situation
          for(let i= 0;i< drinking_situation.length; i++){
            const drinking_name = {'name': drinking_situation[i]['title'] }
            this.drinking_situation.push(drinking_name)
          }
          // 兄弟姐妹
          this.brothers_sisters = []
          const brothers_sisters= res.data.data.brothers_sisters
          for(let i= 0;i< brothers_sisters.length; i++){
            const brothers_name = {'name': brothers_sisters[i]['title'] }
            this.brothers_sisters.push(brothers_name)
          }
          // 對結婚的要求
          this.requirements_marriage = []
          const requirements_marriage= res.data.data.requirements_marriage
          for(let i= 0;i< requirements_marriage.length; i++){
            const requirements_name = {'name': requirements_marriage[i]['title'] }
            this.requirements_marriage.push(requirements_name)
          }
          // 要不要小孩
          this.want_children = []
          const want_children= res.data.data.want_children
          for(let i= 0;i< want_children.length; i++){
            const want_name = {'name': want_children[i]['title'] }
            this.want_children.push(want_name)
          }
          // 交友状态
          this.friendship_status = []
          const friendship_status= res.data.data.friendship_status
          for(let i= 0;i< friendship_status.length; i++){
            const friendship_name = {'name': friendship_status[i]['title'] }
            this.friendship_status.push(friendship_name)
          }
          // 约会费用
          this.appointment_fee = []
          const appointment_fee= res.data.data.appointment_fee
          for(let i= 0;i< appointment_fee.length; i++){
            const appointment_name = {'name': appointment_fee[i]['title'] }
            this.appointment_fee.push(appointment_name)
          }
          // 国籍
          this.nationality = []
          const nationality= res.data.data.nationality
          for(let i= 0;i< nationality.length; i++){
            this.nationality.push( nationality[i]['name'])
          }
          // 语言
          this.language = []
          const language= res.data.data.language
          for(let i= 0;i< language.length; i++){
            const language_name = {'title':language[i]['title'],'status':0}
            this.language.push(language_name)
          }
          // 性格
          this.character = []
          const character= res.data.data.character
          for(let i= 0;i< character.length; i++){
            const character_name = {'title':character[i]['title'],'status':0}
            this.character.push(character_name)
          }
          // 居住情况
          this.living_conditions = []
          const living_conditions= res.data.data.living_conditions
          for(let i= 0;i< living_conditions.length; i++){
            const living_name = {'name': living_conditions[i]['title'] }
            this.living_conditions.push(living_name)
          }
          // 休息日
          this.rest_day = []
          const rest_day= res.data.data.rest_day
          for(let i= 0;i< rest_day.length; i++){
            const day_name = {'name': rest_day[i]['title'] }
            this.rest_day.push(day_name)
          }
          // 社交性
          this.sociality = []
          const sociality= res.data.data.sociality
          for(let i= 0;i< sociality.length; i++){
            const sociality_name = {'name': sociality[i]['title'] }
            this.sociality.push(sociality_name)
          }
        })
      },
			submits: function(){
        this.is_loading = true
        console.log(this.is_loading)
				const uid = this.$route.query.uid
				const token = this.$route.query.token
        let language = ''
        let character= ''
        for(let i=0;i < this.language.length; i++ ){
          if(this.language[i].status == 1){
            language = language + this.language[i].title + ','
          }
        }
        for(let i=0;i < this.character.length; i++ ){
          if(this.character[i].status == 1){
            character = character + this.character[i].title + ','
          }
        }
        if(language){
          language =language.substring(0,language.length - 1)
        }
        if(character) {
          character=character.substring(0,character.length - 1)
        }
        const age = this.user.age === this.$t('user.AgedeFault') ? 0 : this.user.age
	      if(document.getElementsByClassName('el-message').length === 0){
	        axios.get(this.baseUrlApi + "mapi/public/index.php/api/user_api/vue_add_user_information", {
	          params: {
	            uid: uid,
	            token: token,
	            user_nickname:this.user.user_nickname,
	            avatar:this.user.avatar,
	            height:this.user.height,
	            age: age,
	            diploma:this.user.diploma,
	            marriage:this.user.marriage,
	            signature:this.user.signature,
	            monthly_income:this.user.monthly_income,
	            professional:this.user.professional,
	            province:this.user.province,
	            city:this.user.city,
              shape:this.user.shape,
              children:this.user.children,

              blood_type: this.user.blood_type,
              birthplace: this.user.birthplace,
              Smoking: this.user.Smoking,
              drinking_situation: this.user.drinking_situation,
              brothers_sisters: this.user.brothers_sisters,
              nationality: this.user.nationality,
              school: this.user.school,
              requirements_marriage: this.user.requirements_marriage,
              want_children: this.user.want_children,
              friendship_status: this.user.friendship_status,
              appointment_fee: this.user.appointment_fee,
              living_conditions: this.user.living_conditions,
              rest_day: this.user.rest_day,
              sociality: this.user.sociality,
              hobby: this.user.hobby,
              language: language,
              character: character
	          }
	        }).then(res => {
            Toast(res.data.msg)
	          if(res.data.code == 1){
	              this.convert()
	          }
            this.is_loading = false
	        })
	      }
			}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/basic_information.vue